import { Stack } from "@mantine/core";
import { createFileRoute } from "@tanstack/react-router";

import { DashboardComponents } from "@/features/dashboard/_components/dashboard";
import { TruckForm } from "@/features/dashboard/caminhoes/components/TruckForm";

export const Route = createFileRoute("/_private/dashboard/_trucks/caminhoes/modelos/cadastrar/")({
  component: RouteComponent
});

function RouteComponent() {
  return (
    <Stack>
      <DashboardComponents.Title>Cadastrar Modelo de Caminhão</DashboardComponents.Title>

      <TruckForm />
    </Stack>
  );
}
